import { put, call, takeLeading } from 'typed-redux-saga';

import DashboardGateway from '~apis/dashboard';

import { store } from '~redux/store';
import combinedActions from '~redux/combinedActions';
import { ErrorMessages } from '~utils/constants';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

export default function* watchGetDashboardSilverProductPricing(api: DashboardGateway): SagaWatcherReturnType {
    yield takeLeading('dashboard/dashboardGetDashboardSilverProductPricingAttempt', handleGetDashboardSilverProductPricing, api);
}

function* handleGetDashboardSilverProductPricing(api: DashboardGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const response = yield* call([api, api.getDashboardSilverProductPricing], {
        authToken,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.dashboardGetDashboardSilverProductPricingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.dashboardGetDashboardSilverProductPricingSuccess(response.data));
    }
}
